<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
              primary--text
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
          >{{ translations.kitType }}</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-form ref="form" lazy-validation>
          <v-autocomplete
            v-model="data.name"
            outlined
            clearable
            dense
            :label="translations.selectKitType"
            class="
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
            :items="kitTypes"
            item-text="text"
            :rules="validation(translations.field_required)"
          ></v-autocomplete>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col class="text-end">
              <v-btn
                color="primary"
                @click="show = false"
                text
                x-small
                class="
              mb-5
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
              >
                {{ translations.cancel }}
              </v-btn>
              <v-btn
                color="primary"
                @click="sendSamples"
                text
                x-small
                class="
              mb-5
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
              >
                {{ translations.accept }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
// Validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    data: { error: false, message: "", name: "" },
    kitTypes: [],
  }),
  created() {
    this.kitTypes = [
      // { text: this.translations.kitTypes["CLASSIC"], value: "CLASSIC" },
      { text: this.translations.kitTypes["HYBRID"], value: "HYBRID" },
      { text: this.translations.kitTypes["QPCR"], value: "QPCR" },
    ];
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    validation(value) {
      return requiredValidation(value);
    },
    sendSamples() {
      if (this.$refs.form.validate()) {
        this.$emit("getKitType", this.data.name);
        this.show = false;
      }
    },
  },
};
</script>

<style scoped></style>
